/*=========================================================================================
  File Name: vue.config.js
  Description: configuration file of vue
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


module.exports = {
  devServer: {
    //proxy: 'http://localhost:62114/'
    proxy: 'https://api.bistpay.com/'
    //proxy: 'http://192.168.100.20:222/'
    //proxy: 'http://192.168.100.113:222/'
    //proxy: 'http://192.168.100.147:45455'
  },
  publicPath: '/',
  transpileDependencies: [
    'vue-echarts',
    'resize-detector'
  ],
  configureWebpack: {
    optimization: {
      splitChunks: {
        chunks: 'all'
      }
    }
  }
}

